import { IconButton, Tooltip } from '@mui/material'
import { FileText } from 'lucide-react'

import { AttachmentsVariantProps } from '#/components/FormatCell/Types/attachments/types'

export function AttachmentsIcon({ filename, onClick }: AttachmentsVariantProps) {
  return (
    <Tooltip title={filename}>
      <IconButton onClick={onClick}>
        <FileText size={20} />
      </IconButton>
    </Tooltip>
  )
}
